import { apolloClient } from '../../apollo'
import router from '@/router'

const state = {
  currentOrgId: null,
  current: {}
}

const mutations = {
  setSelected (state, id) {
    state.currentOrgId = id
  },

  set (state, org) {
    state.current = org

    if (!org.dataGeneral) { // First use, user must add settings
      router.push({
        name: 'settings organization'
      })
    }
  }
}

const actions = {
  async fetchDetails (context) {
    const { data } = await apolloClient.query({
      query: require('../../graphql/getOrganization.gql'),
      variables: {
        orgId: context.state.currentOrgId
      }
    })

    context.commit('set', data.getOrganization)
  }
}

const getters = {
  hasExports (state) {
    return state.current.exportMethods && state.current.exportMethods.length > 0
  },

  isFirstUse (state) {
    return !state.current.dataGeneral
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
